// extracted by mini-css-extract-plugin
export default {"title":"create-modal_title__2B6+o"};